import { render } from "./ResidentcardTab.vue?vue&type=template&id=11b306ba&scoped=true"
import script from "./ResidentcardTab.vue?vue&type=script&lang=js"
export * from "./ResidentcardTab.vue?vue&type=script&lang=js"

import "./ResidentcardTab.vue?vue&type=style&index=0&id=11b306ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b306ba"]])

export default __exports__